export const TransferTypes = {
  full: 'full',
  partial: 'partial',
};

export const TransferInputTypes = {
  Amount: 'Amount',
  Percentage: 'Percentage'
};
